<aero-button
  [ngClass]="styleClass ? styleClass : null"
  class="page-header-button submit-button"
  icon="{{ isSubmitted ? 'far fa-times' : 'far fa-check'}}"
  label="{{ isSubmitted ? ('assignment.unsubmit' | transloco) : ('assignment.submit'  | transloco) }}"
  pTooltip="{{ !isSubmitted && isShareDisabled ? ('assignment.toolTip' | transloco) : '' }}"
  tooltipPosition="bottom"
  [aeroStyle]="buttonStyle"
  [disabled]="!isSubmitted && isShareDisabled"
  [size]="buttonSize"
  (click)="toggleSubmit()"
>
</aero-button>
